import { createSharedComposable, useDark } from '@vueuse/core';

// The theme contract. The inline pre-paint script in index.html hard-codes the same three values (it runs
// before any module loads), and PrimeVuePlugin's darkModeSelector and index.css key off DARK_THEME.
export const THEME_STORAGE_KEY = 'vueuse-color-scheme';
export const DARK_THEME = 'dark';
export const LIGHT_THEME = 'emerald';

/**
 * The app's one dark-mode ref: `true` when `<html data-theme>` is the dark theme. Writing it switches the theme
 * and saves the choice (to 'auto' when it matches the OS preference, as useDark does).
 *
 * Every caller shares a single useDark, so there is one writer of `data-theme`. There used to be ten, two of them
 * on useDark's default `class` config, which wrote a stray `html.dark` class nothing styles.
 * App.vue holds it for the app's lifetime, so the saved theme is applied on every route, /sign-in included, and
 * not only once a header's toggle mounts.
 */
export const useAppDark = createSharedComposable( () => useDark( {
    selector: 'html',
    attribute: 'data-theme',
    storageKey: THEME_STORAGE_KEY,
    valueDark: DARK_THEME,
    valueLight: LIGHT_THEME,
} ) );
